export const contextId = "motion-state";
export const presenceId = "motion-presence";
export const prefix = "oku-motion";
